import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookOpen,
  faGear,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import Swal from "sweetalert2";
import swal from "sweetalert";

import { APISD } from "../../../../../config/apisd";
import { APIMS } from "../../../../../config/apims";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";

import "bulma/css/bulma.css";
import "../../../../../index.css";

const pageStyles = `
  @keyframes ekskulShimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }

  .ekskul-shimmer {
    animation: ekskulShimmer 1.2s linear infinite;
    background: linear-gradient(
      to right,
      #ddeaff 8%,
      #f4f8ff 18%,
      #ddeaff 33%
    );
    background-size: 800px 104px;
  }

    .ekskul-tabs-card {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    padding: 6px;
    border: 1px solid #dce3ef;
    border-radius: 14px;
    background: #ffffff;
  }

  .ekskul-tab-button {
    min-width: 150px;
    height: 42px;
    padding: 0 24px;
    border: 0;
    border-radius: 10px;
    background: transparent;
    color: #65708b;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition:
      background 0.2s ease,
      color 0.2s ease,
      box-shadow 0.2s ease;
  }

  .ekskul-tab-button:hover {
    background: #f5f7ff;
    color: #3f5bea;
  }

  .ekskul-tab-button.active {
    background: #3f5bea;
    color: #ffffff;
    box-shadow: 0 6px 14px rgba(63, 91, 234, 0.18);
  }

  .ekskul-tab-button.active:hover {
    background: #3f5bea;
    color: #ffffff;
  }

  .ekskul-toolbar-card {
    display: flex;
    width: 100%;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;
    padding: 18px;
    border: 1px solid #e5eaf4;
    border-radius: 16px;
    background: #ffffff;
  }

  .ekskul-filter-side {
    display: flex;
    min-width: 0;
    flex: 1;
    align-items: flex-end;
    gap: 12px;
  }

  .ekskul-filter-field {
    width: min(100%, 310px);
    min-width: 220px;
  }

  .ekskul-filter-label {
    display: block;
    margin-bottom: 7px;
    color: #17213d;
    font-size: 12.5px;
    font-weight: 700;
  }

  .ekskul-filter-select {
    width: 100%;
    height: 44px;
    padding: 0 38px 0 13px;
    border: 1px solid #dce3ef;
    border-radius: 10px;
    outline: none;
    background: #ffffff;
    color: #27324f;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .ekskul-filter-select:focus {
    border-color: #7892ff;
    box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.08);
  }

  .ekskul-filter-button {
    display: inline-flex;
    height: 44px;
    align-items: center;
    justify-content: center;
    padding: 0 18px;
    border: 0;
    border-radius: 10px;
    background: #f4aa33;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 7px 16px rgba(63, 91, 234, 0.18);
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  .ekskul-filter-button:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .ekskul-filter-button:disabled {
    cursor: not-allowed;
    background: #c9cfdd;
    box-shadow: none;
  }

  .ekskul-toolbar-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 9px;
    flex-wrap: wrap;
  }

  .ekskul-config-button {
    display: inline-flex;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 14px;
    border: 1px solid #dce3ef;
    border-radius: 10px;
    background: #ffffff;
    color: #3d4a66;
    font-size: 12.5px;
    font-weight: 700;
    text-decoration: none;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  }

  .ekskul-config-button:hover {
    border-color: #7892ff;
    background: #f7f9ff;
    color: #315fc5;
    text-decoration: none;
  }

  .ekskul-skeleton-select {
    width: 280px;
    height: 44px;
    border-radius: 10px;
  }

  .ekskul-skeleton-button {
    width: 112px;
    height: 44px;
    border-radius: 10px;
  }

  .ekskul-search-wrap {
    margin-bottom: 14px;
  }

  .ekskul-table {
    min-width: 620px;
  }

  .ekskul-col-name {
    width: auto;
  }

  .ekskul-col-action {
    width: 180px;
    text-align: center !important;
  }

  .ekskul-action-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    white-space: nowrap;
  }

  .ekskul-action-wrap .module-action-button {
    width: 34px;
    height: 34px;
    padding: 0;
    border-radius: 9px;
    font-size: 13px;
  }

  .ekskul-action-wrap .module-action-edit {
    border-color: #d9e3ff;
    background: #eef3ff;
    color: #315fc5;
  }

  .ekskul-action-wrap .module-action-delete {
    border-color: #ffe0e0;
    background: #fff1f1;
    color: #d84b4b;
  }

  .ekskul-info-filter-card {
  display: flex;
  width: 100%;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 18px;
  padding: 18px;
  border: 1px solid #e5eaf4;
  border-radius: 16px;
  background: #ffffff;
}

.ekskul-info-filter-grid {
  display: grid;
  min-width: 0;
  flex: 1;
  grid-template-columns: repeat(
    3,
    minmax(180px, 1fr)
  );
  gap: 12px;
}

.ekskul-info-filter-grid
  .ekskul-filter-field {
  width: 100%;
  min-width: 0;
}


.ekskul-info-table thead th {
  vertical-align: middle;
  text-align: center;
}

.ekskul-info-table
  .ekskul-info-col-name,
.ekskul-info-table
  .ekskul-info-col-grade,
.ekskul-info-table
  .ekskul-info-col-teacher {
  text-align: left;
}

.ekskul-info-col-name {
  min-width: 170px;
}

.ekskul-info-col-grade {
  min-width: 330px;
}

.ekskul-info-col-teacher {
  min-width: 300px;
}

.ekskul-info-col-student {
  width: 112px;
  text-align: center !important;
}

.ekskul-info-grade-list {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.ekskul-info-grade-badge {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 7px;
  background: #2468c9;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.15;
  white-space: nowrap;
  box-shadow:
    0 3px 8px rgba(36, 104, 201, 0.16);
}

.ekskul-info-teacher-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ekskul-info-teacher-item {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.ekskul-info-teacher-avatar {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #dfe7f5;
  border-radius: 50%;
  background: #eef3ff;
  color: #315fc5;
  font-size: 11px;
  font-weight: 800;
}

.ekskul-info-teacher-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ekskul-info-teacher-name {
  overflow: hidden;
  color: #35405b;
  font-size: 13px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ekskul-info-student-total {
  color: #20b779;
  font-size: 14px;
  font-weight: 800;
}

.ekskul-info-action-wrap
  .module-action-edit {
  border-color: #ffd894;
  background: #fffaf0;
  color: #f4a21b;
}

.ekskul-info-action-wrap
  .module-action-delete {
  border-color: #ffd8df;
  background: #fff3f5;
  color: #ef5365;
}

  @media (max-width: 900px) {
    .ekskul-toolbar-card {
      align-items: stretch;
      flex-direction: column;
    }

    .ekskul-toolbar-actions {
      justify-content: flex-start;
    }
      
    .ekskul-info-filter-card {
      align-items: stretch;
      flex-direction: column;
    }

    .ekskul-info-filter-grid {
      grid-template-columns:
        repeat(2, minmax(180px, 1fr));
    }
  }

  @media (max-width: 780px) {
    .ekskul-tabs-card {
      gap: 6px;
      padding: 5px;
      border-radius: 12px;
    }

    .ekskul-tab-button {
      min-width: 0;
      flex: 1;
      padding: 0 12px;
    }

    .page-header-top {
      align-items: center;
      gap: 10px;
    }

    .ekskul-toolbar-card {
      gap: 14px;
      padding: 15px;
      border-radius: 13px;
    }

    .ekskul-filter-side {
      width: 100%;
      align-items: stretch;
      flex-direction: column;
    }

    .ekskul-filter-field {
      width: 100%;
      min-width: 0;
    }

    .ekskul-filter-button,
    .ekskul-toolbar-actions,
    .ekskul-config-button,
    .ekskul-toolbar-actions .btn-create {
      width: 100%;
    }

    .ekskul-toolbar-actions {
      align-items: stretch;
      flex-direction: column;
    }

    .ekskul-table {
      min-width: 590px;
    }

    .ekskul-info-filter-card {
      gap: 14px;
      padding: 15px;
      border-radius: 13px;
    }

    .ekskul-info-filter-grid {
      grid-template-columns: 1fr;
    }

    .ekskul-info-filter-card
      .ekskul-filter-button {
      width: 100%;
    }

    
  }

  .ekskul-info-table-scroll {
  width: 100%;
  overflow-x: hidden;
}

.ekskul-info-table {
  width: 100%;
  min-width: 0 !important;
  table-layout: fixed;
}

.ekskul-info-table th,
.ekskul-info-table td {
  vertical-align: middle;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
}

.ekskul-info-table thead th {
  vertical-align: middle;
  text-align: center;
}

/* NO */
.ekskul-info-table .module-col-number {
  width: 6%;
  min-width: 45px;
}

/* EKSTRAKURIKULER */
.ekskul-info-col-name {
  width: 18%;
  text-align: left !important;
}

/* TINGKATAN */
.ekskul-info-col-grade {
  width: 20%;
  text-align: left !important;
}

/* PEMBINA */
.ekskul-info-col-teacher {
  width: 28%;
  text-align: left !important;
}

/* JUMLAH SISWA */
.ekskul-info-col-student {
  width: 18%;
  text-align: center !important;
}

.ekskul-info-grade-list {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.ekskul-info-grade-badge {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 7px;
  background: #2468c9;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.15;
  white-space: nowrap;
  box-shadow: 0 3px 8px rgba(36, 104, 201, 0.16);
}

.ekskul-info-teacher-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ekskul-info-teacher-item {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.ekskul-info-teacher-avatar {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #dfe7f5;
  border-radius: 50%;
  background: #eef3ff;
  color: #315fc5;
  font-size: 11px;
  font-weight: 800;
}

.ekskul-info-teacher-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ekskul-info-teacher-name {
  min-width: 0;
  color: #35405b;
  font-size: 13px;
  line-height: 1.35;

  /* jangan paksa 1 baris */
  white-space: normal;
  overflow-wrap: anywhere;
}

.ekskul-info-student-total {
  color: #20b779;
  font-size: 14px;
  font-weight: 800;
}

/* ==================================================
   TABLET / LAPTOP KECIL
   tetap fit, TIDAK horizontal scroll
================================================== */
@media (max-width: 900px) {
  .ekskul-info-table-scroll {
    overflow-x: hidden;
  }

  .ekskul-info-table {
    width: 100%;
    min-width: 0 !important;
    table-layout: fixed;
  }

  .ekskul-info-table th,
  .ekskul-info-table td {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }

  .ekskul-info-grade-badge {
    padding: 4px 7px;
    font-size: 11px;
  }

  .ekskul-info-teacher-avatar {
    width: 30px;
    height: 30px;
    flex-basis: 30px;
  }

  .ekskul-info-teacher-name {
    font-size: 12px;
  }
}

/* ==================================================
   HP
   baru diperbolehkan horizontal scroll
================================================== */
@media (max-width: 640px) {
  .ekskul-info-table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ekskul-info-table {
    width: 760px;
    min-width: 760px !important;
    table-layout: fixed;
  }

  .ekskul-info-table .module-col-number {
    width: 55px;
  }

  .ekskul-info-col-name {
    width: 140px;
  }

  .ekskul-info-col-grade {
    width: 180px;
  }

  .ekskul-info-col-teacher {
    width: 220px;
  }

  .ekskul-info-col-student {
    width: 82px;
  }
}


/* ==================================================
   LINK PEMBINA
================================================== */

.ekskul-pembina-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #315fc5;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s ease;
}

.ekskul-pembina-link:hover {
  color: #234da9;
  text-decoration: underline;
}

.ekskul-pembina-count {
  display: inline-flex;
  min-width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 7px;
  background: #eef3ff;
  color: #315fc5;
  font-size: 11px;
  font-weight: 800;
  text-decoration: none;
}


/* ==================================================
   MODAL PEMBINA
================================================== */

.ekskul-pembina-modal-overlay {
  position: fixed;
  z-index: 9999;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(18, 27, 52, 0.46);
  backdrop-filter: blur(2px);
}

.ekskul-pembina-modal {
  width: min(720px, 100%);
  max-height: calc(100vh - 40px);
  overflow: hidden;
  border: 1px solid #e2e8f3;
  border-radius: 18px;
  background: #ffffff;
  box-shadow:
    0 22px 60px rgba(25, 39, 78, 0.18);
  animation: ekskulPembinaModalShow 0.2s ease;
}

@keyframes ekskulPembinaModalShow {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}


/* HEADER */

.ekskul-pembina-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px;
  border-bottom: 1px solid #edf0f6;
}

.ekskul-pembina-modal-label {
  display: block;
  margin-bottom: 3px;
  color: #7b849d;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.ekskul-pembina-modal-title {
  margin: 0;
  color: #17213d;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.35;
}

.ekskul-pembina-modal-close {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e1e6ef;
  border-radius: 9px;
  background: #ffffff;
  color: #67718a;
  font-size: 24px;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}

.ekskul-pembina-modal-close:hover {
  border-color: #d7def0;
  background: #f7f9fd;
  color: #315fc5;
}


/* BODY */

.ekskul-pembina-modal-body {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
  padding: 20px 22px;
}


/* SUMMARY */

.ekskul-pembina-summary {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  gap: 10px;
  margin-bottom: 18px;
}

.ekskul-pembina-summary-item {
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #e5eaf4;
  border-radius: 11px;
  background: #f9fbff;
}

.ekskul-pembina-summary-label {
  display: block;
  margin-bottom: 4px;
  color: #8490aa;
  font-size: 11px;
  font-weight: 600;
}

.ekskul-pembina-summary-item strong {
  display: block;
  overflow: hidden;
  color: #26314f;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}


/* TABLE */

.ekskul-pembina-table-card {
  overflow: hidden;
  border: 1px solid #e5eaf4;
  border-radius: 13px;
  background: #ffffff;
}

.ekskul-pembina-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.ekskul-pembina-table {
  width: 100%;
  border-collapse: collapse;
}

.ekskul-pembina-table th {
  padding: 13px 14px;
  border-bottom: 1px solid #e8ecf4;
  background: #f3f6ff;
  color: #202c4c;
  font-size: 12px;
  font-weight: 800;
  text-align: left;
  vertical-align: middle;
}

.ekskul-pembina-table td {
  padding: 13px 14px;
  border-bottom: 1px solid #eef1f6;
  color: #35405b;
  font-size: 13px;
  vertical-align: middle;
}

.ekskul-pembina-table tbody tr:last-child td {
  border-bottom: 0;
}

.ekskul-pembina-table tbody tr:hover {
  background: #fbfcff;
}

.ekskul-pembina-no {
  width: 65px;
  text-align: center !important;
}


/* BADGE KELAS */

.ekskul-pembina-grade-badge {
  display: inline-flex;
  min-width: 32px;
  min-height: 28px;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 7px;
  background: #2468c9;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
}


/* PEMBINA */

.ekskul-pembina-teacher {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.ekskul-pembina-avatar {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #dfe7f5;
  border-radius: 50%;
  background: #eef3ff;
  color: #315fc5;
  font-size: 11px;
  font-weight: 800;
}

.ekskul-pembina-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ekskul-pembina-name {
  min-width: 0;
  color: #35405b;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.ekskul-pembina-not-set {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 7px;
  background: #f4f5f8;
  color: #8a93a8;
  font-size: 11px;
  font-weight: 600;
}

.ekskul-pembina-empty {
  padding: 30px 15px !important;
  color: #8a93a8 !important;
  text-align: center;
}


/* FOOTER */

.ekskul-pembina-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 22px;
  border-top: 1px solid #edf0f6;
  background: #fbfcfe;
}

.ekskul-pembina-close-button {
  display: inline-flex;
  height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border: 1px solid #dfe5ef;
  border-radius: 9px;
  background: #ffffff;
  color: #45516d;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;
}

.ekskul-pembina-close-button:hover {
  border-color: #cad4e7;
  background: #f5f7fb;
}


/* RESPONSIVE */

@media (max-width: 640px) {
  .ekskul-pembina-modal-overlay {
    align-items: flex-end;
    padding: 10px;
  }

  .ekskul-pembina-modal {
    width: 100%;
    max-height: 90vh;
    border-radius: 16px;
  }

  .ekskul-pembina-modal-header {
    padding: 17px;
  }

  .ekskul-pembina-modal-body {
    padding: 16px;
  }

  .ekskul-pembina-summary {
    grid-template-columns: 1fr 1fr;
  }

  .ekskul-pembina-summary-item:first-child {
    grid-column: 1 / -1;
  }

  .ekskul-pembina-modal-footer {
    padding: 12px 16px;
  }

  .ekskul-pembina-close-button {
    width: 100%;
  }

  .ekskul-pembina-table {
    min-width: 470px;
  }
}


/* =========================================
   GROUP PEMBINA PER KELAS
========================================= */

.ekskul-pembina-rowspan-cell {
  vertical-align: middle !important;
}

.ekskul-pembina-grade-cell {
  width: 120px;
  text-align: left;
  vertical-align: middle !important;
}

.ekskul-pembina-no {
  width: 70px;
  text-align: center !important;
  vertical-align: middle !important;
}

/* garis antar pembina dalam kelas yang sama */
.ekskul-pembina-teacher-row td {
  border-bottom: 1px solid #eef1f6;
}

/*
  Cell NO dan KELAS yang menggunakan rowspan
  tetap punya garis bawah setelah satu kelompok kelas selesai
*/
.ekskul-pembina-rowspan-cell {
  border-bottom: 1px solid #dfe5f0 !important;
}

/* pembina */
.ekskul-pembina-teacher {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
}

/* agar avatar + nama tidak terlalu mepet */
.ekskul-pembina-table td {
  padding-top: 12px;
  padding-bottom: 12px;
}

`;

export default function DataEkskul() {
  document.title = "Data Ekstrakurikuler";

  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level");

  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [branches, setBranches] = useState([]);
  const [data, setData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [activeTab, setActiveTab] = useState("ekstrakurikuler");

  const [academicYears, setAcademicYears] = useState([]);
  const [infoSchools, setInfoSchools] = useState([]);
  const [infoData, setInfoData] = useState([]);

  const [infoLoading, setInfoLoading] = useState(false);
  const [infoSchoolLoading, setInfoSchoolLoading] = useState(false);
  const [hasInfoSearched, setHasInfoSearched] = useState(false);

  const [modalPembina, setModalPembina] = useState(false);
  const [selectedPembinaEkskul, setSelectedPembinaEkskul] = useState(null);

  const [formInfo, setFormInfo] = useState({
    ysb_academic_year_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });


  const [formFilter, setFormFilter] = useState({
    ysb_branch_id: "",
  });

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const location = useLocation();
  const navigate = useNavigate();

  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const firstLoadDone = useRef(false);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  useEffect(() => {
    const rolePermissions =
      JSON.parse(localStorage.getItem("role_permission")) || [];

    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });

      return;
    }

    const foundPermission = rolePermissions.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: foundPermission.create,
      read: foundPermission.read,
      update: foundPermission.update,
      delete: foundPermission.delete,
    });
  }, [location.pathname, navigate, storageLevel]);

  const fetchBranches = useCallback(async () => {
    setLoading(true);

    try {
      const response = await APIMS.get(
        "/api/access/branches?page=1&limit=1000&ascending=1&search=",
        fetchParams
      );

      const branchData = response?.data?.data || [];

      setBranches(branchData);

      // if (branchData.length > 0) {
      //   setFormFilter((previous) => ({
      //     ...previous,
      //     ysb_branch_id:
      //       previous.ysb_branch_id || branchData[0]?.branch_code || "",
      //   }));
      // }

      if (branchData.length > 0) {
        const firstBranch = branchData[0]?.branch_code || "";

        setFormFilter((previous) => ({
          ...previous,
          ysb_branch_id: previous.ysb_branch_id || firstBranch,
        }));

        setFormInfo((previous) => ({
          ...previous,
          ysb_branch_id: previous.ysb_branch_id || firstBranch,
        }));
      }
    } catch (error) {
      setBranches([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data cabang",
      });
    } finally {
      setLoading(false);
    }
  }, [fetchParams]);

  useEffect(() => {
    fetchBranches();
  }, [fetchBranches]);

  const fetchAcademicYears = useCallback(async () => {
    try {
      const response = await APIMS.get(
        "/api/academic-years?page=1&limit=1000&ascending=0&search=",
        fetchParams
      );

      const academicYearData = response?.data?.data || [];

      setAcademicYears(academicYearData);

      const activeAcademicYear =
        academicYearData.find(
          (item) =>
            item?.status === 1 ||
            item?.status === "1" ||
            item?.is_active === 1 ||
            item?.is_active === true
        ) || academicYearData[0];

      if (activeAcademicYear) {
        setFormInfo((previous) => ({
          ...previous,
          ysb_academic_year_id:
            previous.ysb_academic_year_id ||
            activeAcademicYear?.id ||
            "",
        }));
      }
    } catch (error) {
      setAcademicYears([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data tahun akademik",
      });
    }
  }, [fetchParams]);

  useEffect(() => {
    fetchAcademicYears();
  }, [fetchAcademicYears]);

  const sortSchools = (schools = []) => {
    const order = ["TK", "SD", "SMP", "SMA"];

    return [...schools].sort((first, second) => {
      const firstName = String(
        first?.school_name || ""
      ).toUpperCase();

      const secondName = String(
        second?.school_name || ""
      ).toUpperCase();

      const firstIndex = order.findIndex((item) =>
        firstName.includes(item)
      );

      const secondIndex = order.findIndex((item) =>
        secondName.includes(item)
      );

      if (firstIndex !== secondIndex) {
        return (
          (firstIndex === -1 ? order.length : firstIndex) -
          (secondIndex === -1 ? order.length : secondIndex)
        );
      }

      return firstName.localeCompare(secondName, "id", {
        numeric: true,
        sensitivity: "base",
      });
    });
  };

  const fetchInfoSchools = useCallback(
    async (branchId) => {
      if (!branchId) {
        setInfoSchools([]);
        return;
      }

      setInfoSchoolLoading(true);

      try {
        const response = await APIMS.get(
          `/api/access/schools?page=1&limit=1000&ascending=1&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        let schoolData = response?.data?.data || [];

        if (
          storageLevel === "developer" ||
          storageLevel === "superadmin"
        ) {
          schoolData = schoolData.filter(
            (item) =>
              String(item?.ysb_branch_id) === String(branchId)
          );
        }

        if (branchId === "BKS") {
          schoolData = schoolData.filter(
            (item) =>
              item?.school_code !== "BASEMENT_BEKASI"
          );
        }

        schoolData = sortSchools(schoolData);

        setInfoSchools(schoolData);

        setFormInfo((previous) => {
          const schoolExists = schoolData.some(
            (item) =>
              String(item?.school_code) ===
              String(previous.ysb_school_id)
          );

          return {
            ...previous,
            ysb_school_id: schoolExists
              ? previous.ysb_school_id
              : schoolData[0]?.school_code || "",
          };
        });
      } catch (error) {
        setInfoSchools([]);

        setFormInfo((previous) => ({
          ...previous,
          ysb_school_id: "",
        }));

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message ||
            "Gagal mengambil data sekolah",
        });
      } finally {
        setInfoSchoolLoading(false);
      }
    },
    [fetchParams, storageLevel]
  );

  useEffect(() => {
    if (!formInfo.ysb_branch_id) {
      setInfoSchools([]);
      return;
    }

    fetchInfoSchools(formInfo.ysb_branch_id);
  }, [
    fetchInfoSchools,
    formInfo.ysb_branch_id,
  ]);

const GetInfoData = useCallback(async () => {
  const payload = {
    ysb_academic_year_id: formInfo?.ysb_academic_year_id,
    ysb_branch_id: formInfo?.ysb_branch_id,
    ysb_school_id: formInfo?.ysb_school_id,
  };

  if (
    !payload.ysb_academic_year_id ||
    !payload.ysb_branch_id ||
    !payload.ysb_school_id
  ) {
    swal({
      title: "Filter belum lengkap",
      text: "Silakan pilih tahun akademik, cabang, dan sekolah terlebih dahulu.",
      icon: "warning",
    });

    return;
  }

  setInfoLoading(true);

  try {
    console.log("PAYLOAD INFO EKSKUL:", payload);

    const response = await APISD.get(
      `/api/ekstrakurikuler-students/info`,
      {
        ...fetchParams,

        // dikirim sebagai query params
        params: {
          ysb_academic_year_id: formInfo.ysb_academic_year_id,
          ysb_branch_id: formInfo.ysb_branch_id,
          ysb_school_id: formInfo.ysb_school_id,
        },

        // mengikuti pola Config Matpel / Passing Grade:
        // GET dengan Body JSON
        data: {
          ysb_academic_year_id: formInfo.ysb_academic_year_id,
          ysb_branch_id: formInfo.ysb_branch_id,
          ysb_school_id: formInfo.ysb_school_id,
        },
      }
    );

    console.log("RESPONSE INFO EKSKUL:", response?.data);

    if (response?.status === 200) {
      setInfoData(response?.data?.data || []);
      setHasInfoSearched(true);
    }
  } catch (error) {
    console.error(
      "ERROR INFO EKSKUL:",
      error?.response?.data || error
    );

    setInfoData([]);
    setHasInfoSearched(true);

    ToastError.fire({
      icon: "error",
      title:
        error?.response?.data?.message ||
        "Gagal mengambil informasi ekstrakurikuler",
    });
  } finally {
    setInfoLoading(false);
  }
}, [
  fetchParams,
  formInfo.ysb_academic_year_id,
  formInfo.ysb_branch_id,
  formInfo.ysb_school_id,
]);

useEffect(() => {
  // Hanya ambil data ketika tab Informasi sedang dibuka
  if (activeTab !== "info") {
    return;
  }

  // Tunggu proses pengambilan sekolah selesai
  if (infoSchoolLoading) {
    return;
  }

  // Tunggu sampai semua filter lengkap
  if (
    !formInfo.ysb_academic_year_id ||
    !formInfo.ysb_branch_id ||
    !formInfo.ysb_school_id
  ) {
    setInfoData([]);
    setHasInfoSearched(false);
    return;
  }

  GetInfoData();
}, [
  activeTab,
  formInfo.ysb_academic_year_id,
  formInfo.ysb_branch_id,
  formInfo.ysb_school_id,
  infoSchoolLoading,
  GetInfoData,
]);

  const handleInfoFilterChange = (event) => {
    const { name, value } = event.target;

    setFormInfo((previous) => ({
      ...previous,
      [name]: value,

      ...(name === "ysb_branch_id"
        ? {
            ysb_school_id: "",
          }
        : {}),
    }));

    setInfoData([]);
    setHasInfoSearched(false);
  };

  const handleInfoCari = async () => {
    if (
      !formInfo.ysb_academic_year_id ||
      !formInfo.ysb_branch_id ||
      !formInfo.ysb_school_id
    ) {
      swal({
        title: "Filter belum lengkap",
        text: "Silakan pilih tahun akademik, cabang, dan sekolah terlebih dahulu.",
        icon: "warning",
      });

      return;
    }

    await GetInfoData();
  };

  const getSemesterTotal = (item, semesterNumber) => {
    const rows = Array.isArray(item?.jumlah_siswa)
      ? item.jumlah_siswa
      : [];

    const found = rows.find(
      (row) =>
        Number(row?.semester) === Number(semesterNumber)
    );

    return Number(found?.total || 0);
  };

  const getTeacherInitials = (fullName) => {
    const cleanName = String(fullName || "").trim();

    if (!cleanName) {
      return "?";
    }

    return cleanName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) =>
        part.charAt(0).toUpperCase()
      )
      .join("");
  };

  const getTeacherPhoto = (teacher) => {
    return (
      teacher?.photo ||
      teacher?.photo_url ||
      teacher?.profile_picture ||
      teacher?.image ||
      ""
    );
  };

  const getTeacherName = (teacher) => {
  return (
    teacher?.full_name ||
    teacher?.teacher_name ||
    teacher?.name_teacher ||
    teacher?.name ||
    teacher?.nama_guru ||
    "-"
  );
};

const getPembinaRows = (item) => {
  const gradeLevels = Array.isArray(item?.grade_levels)
    ? item.grade_levels
    : [];

  const rows = [];

  gradeLevels.forEach((grade) => {
    const pembinaList = Array.isArray(grade?.pembina)
      ? grade.pembina
      : [];

    if (pembinaList.length === 0) {
      rows.push({
        gradeId: grade?.ysb_grade_level_id,
        gradeName: grade?.name_level || "-",
        teacher: null,
      });

      return;
    }

    pembinaList.forEach((teacher, teacherIndex) => {
      rows.push({
        gradeId: grade?.ysb_grade_level_id,
        gradeName: grade?.name_level || "-",
        teacher,
        teacherIndex,
      });
    });
  });

  return rows;
};

const getTotalPembina = (item) => {
  const gradeLevels = Array.isArray(item?.grade_levels)
    ? item.grade_levels
    : [];

  return gradeLevels.reduce((total, grade) => {
    const pembina = Array.isArray(grade?.pembina)
      ? grade.pembina
      : [];

    return total + pembina.length;
  }, 0);
};

const openModalPembina = (item) => {
  setSelectedPembinaEkskul(item);
  setModalPembina(true);
};

const closeModalPembina = () => {
  setModalPembina(false);
  setSelectedPembinaEkskul(null);
};

  const GetResponseData = useCallback(async () => {
    if (!formFilter.ysb_branch_id) {
      return;
    }

    setIsFetching(true);

    try {
      const response = await APISD.get(
        `/api/ekstrakurikuler?page=1&limit=1000&ascending=1&search=&ysb_branch_id=${formFilter.ysb_branch_id}`,
        fetchParams
      );

      setData(response?.data?.data || []);
      setHasSearched(true);
    } catch (error) {
      setData([]);
      setHasSearched(true);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data mata pelajaran",
      });
    } finally {
      setIsFetching(false);
    }
  }, [fetchParams, formFilter.ysb_branch_id]);

  useEffect(() => {
    if (firstLoadDone.current || !formFilter.ysb_branch_id) {
      return;
    }

    firstLoadDone.current = true;
    GetResponseData();
  }, [formFilter.ysb_branch_id, GetResponseData]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    setFormFilter((previous) => ({
      ...previous,
      [name]: value,
    }));

    setHasSearched(false);
  };

  const handleCari = async () => {
    if (!formFilter.ysb_branch_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Silakan pilih cabang terlebih dahulu.",
        icon: "warning",
      });

      return;
    }

    setSearchKeyword("");
    setData([]);
    setHasSearched(false);

    await GetResponseData();
  };

  const nameCollator = useMemo(
    () =>
      new Intl.Collator("id", {
        sensitivity: "base",
        numeric: true,
      }),
    []
  );

  const filteredData = useMemo(() => {
    const query = searchKeyword.trim().toLowerCase();
    const source = Array.isArray(data) ? data : [];

    const filtered = query
      ? source.filter((item) =>
          String(item?.name_matpel || "")
            .toLowerCase()
            .includes(query)
        )
      : source;

    return [...filtered].sort((first, second) =>
      nameCollator.compare(
        String(first?.name_matpel || "").trim(),
        String(second?.name_matpel || "").trim()
      )
    );
  }, [data, nameCollator, searchKeyword]);

  const totalRows = filteredData.length;

  const totalPages = useMemo(() => {
    const pages = Math.ceil(totalRows / Math.max(1, rowsPerPage));

    return pages <= 0 ? 1 : pages;
  }, [rowsPerPage, totalRows]);

  useEffect(() => {
    setTablePage(1);
  }, [data, searchKeyword]);

  useEffect(() => {
    if (tablePage > totalPages) {
      setTablePage(totalPages);
    }

    if (tablePage < 1) {
      setTablePage(1);
    }
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const start = (tablePage - 1) * rowsPerPage;

    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, rowsPerPage, tablePage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (
        let pageNumber = 1;
        pageNumber <= totalPages;
        pageNumber += 1
      ) {
        pages.push(pageNumber);
      }

      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);

    if (left > 2) {
      pages.push("...");
    }

    for (
      let pageNumber = left;
      pageNumber <= right;
      pageNumber += 1
    ) {
      if (pageNumber !== 1 && pageNumber !== totalPages) {
        pages.push(pageNumber);
      }
    }

    if (right < totalPages - 1) {
      pages.push("...");
    }

    pages.push(totalPages);

    return pages.filter(
      (value, index, array) => array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    const destination = Math.min(
      Math.max(1, Number(nextPage) || 1),
      totalPages
    );

    setTablePage(destination);
  };

  const deleteById = (id) => {
    Swal.fire({
      title: "Apakah kamu yakin?",
      text: "Data yang dihapus tidak dapat dikembalikan.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),

      preConfirm: async () => {
        try {
          const response = await APISD.delete(
            `/api/ekstrakurikuler/${id}`,
            fetchParams
          );

          if (response?.data?.error) {
            throw new Error(response?.data?.message);
          }

          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error?.response?.data?.message ||
              error?.message ||
              "Gagal menghapus data"
          );

          return false;
        }
      },
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      ToastSuccess.fire({
        icon: "success",
        title: "Data berhasil dihapus",
      });

      GetResponseData();
    });
  };

  const openUpdateModal = (item) => {
    setSelectedId(item?.id);
    setSelectedData(item);
    setModalUpdate(true);
  };

  const openInfoUpdateModal = async (item) => {
  const id = item?.ysb_matpel_id;

  if (!id) {
    return;
  }

  try {
    const response = await APISD.get(
      `/api/ekstrakurikuler?page=1&limit=1000&ascending=1&search=&ysb_branch_id=${formInfo.ysb_branch_id}`,
      fetchParams
    );

    const rows = response?.data?.data || [];

    const detail = rows.find(
      (row) =>
        String(row?.id) === String(id)
    );

    setSelectedId(id);

    setSelectedData(
      detail || {
        id,
        name_matpel: item?.name_matpel || "",
      }
    );

    setModalUpdate(true);
  } catch (error) {
    ToastError.fire({
      icon: "error",
      title:
        error?.response?.data?.message ||
        "Gagal mengambil detail ekstrakurikuler",
    });
  }
};

  const getMatpelType = (value) => {
    return Number(value) === 1
      ? "Kokurikuler"
      : "Intrakurikuler";
  };

  return (
    <div className="body sims-page">
      <style>{pageStyles}</style>

      {modalAdd && (
        <ModalAdd
          show={modalAdd}
          onHide={() => setModalAdd(false)}
          GetResponseData={GetResponseData}
          filterData={formFilter}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
          GetResponseData={GetResponseData}
          id={selectedId}
          dataUpdate={selectedData}
        />
      )}

      {/* MODAL PEMBINA */}
      {modalPembina && selectedPembinaEkskul && (
        <div
          className="ekskul-pembina-modal-overlay"
          onClick={closeModalPembina}
        >
          <div
            className="ekskul-pembina-modal"
            onClick={(event) => event.stopPropagation()}
          >
            {/* HEADER */}
            <div className="ekskul-pembina-modal-header">
              <div>
                <span className="ekskul-pembina-modal-label">
                  Pembina Ekstrakurikuler
                </span>

                <h5 className="ekskul-pembina-modal-title">
                  {selectedPembinaEkskul?.name_matpel || "-"}
                </h5>
              </div>

              <button
                type="button"
                className="ekskul-pembina-modal-close"
                onClick={closeModalPembina}
                aria-label="Tutup"
              >
                ×
              </button>
            </div>

            {/* BODY */}
            <div className="ekskul-pembina-modal-body">
              {/* <div className="ekskul-pembina-summary">
                <div className="ekskul-pembina-summary-item">
                  <span className="ekskul-pembina-summary-label">
                    Ekstrakurikuler
                  </span>

                  <strong>
                    {selectedPembinaEkskul?.name_matpel || "-"}
                  </strong>
                </div>

                <div className="ekskul-pembina-summary-item">
                  <span className="ekskul-pembina-summary-label">
                    Jumlah Tingkatan
                  </span>

                  <strong>
                    {Array.isArray(
                      selectedPembinaEkskul?.grade_levels
                    )
                      ? selectedPembinaEkskul.grade_levels.length
                      : 0}
                  </strong>
                </div>

                <div className="ekskul-pembina-summary-item">
                  <span className="ekskul-pembina-summary-label">
                    Jumlah Pembina
                  </span>

                  <strong>
                    {getTotalPembina(selectedPembinaEkskul)}
                  </strong>
                </div>
              </div> */}

              <div className="ekskul-pembina-table-card">
                <div className="ekskul-pembina-table-scroll">
                  <table className="ekskul-pembina-table">
                    <thead>
                      <tr>
                        <th className="ekskul-pembina-no">
                          No
                        </th>

                        <th>
                          Tingkatan
                        </th>

                        <th>
                          Nama Pembina
                        </th>
                      </tr>
                    </thead>

                    {/* <tbody>
                      {getPembinaRows(
                        selectedPembinaEkskul
                      ).length === 0 ? (
                        <tr>
                          <td
                            colSpan={3}
                            className="ekskul-pembina-empty"
                          >
                            Belum ada data pembina
                          </td>
                        </tr>
                      ) : (
                        getPembinaRows(
                          selectedPembinaEkskul
                        ).map((row, rowIndex) => {
                          const teacherPhoto =
                            row?.teacher
                              ? getTeacherPhoto(
                                  row.teacher
                                )
                              : "";

                          const teacherName =
                            row?.teacher
                              ? getTeacherName(
                                  row.teacher
                                )
                              : "-";

                          return (
                            <tr
                              key={`${row?.gradeId || "grade"}-${
                                row?.teacher?.ysb_teacher_id ||
                                row?.teacher?.id ||
                                row?.teacherIndex ||
                                rowIndex
                              }`}
                            >
                              <td className="ekskul-pembina-no">
                                <span className="module-number-badge">
                                  {rowIndex + 1}
                                </span>
                              </td>

                              <td>
                                <span className="ekskul-pembina-grade-badge">
                                  {row?.gradeName || "-"}
                                </span>
                              </td>

                              <td>
                                {row?.teacher ? (
                                  <div className="ekskul-pembina-teacher">
                                    <span className="ekskul-pembina-avatar">
                                      {teacherPhoto ? (
                                        <img
                                          src={teacherPhoto}
                                          alt={teacherName}
                                        />
                                      ) : (
                                        getTeacherInitials(
                                          teacherName
                                        )
                                      )}
                                    </span>

                                    <span className="ekskul-pembina-name">
                                      {teacherName}
                                    </span>
                                  </div>
                                ) : (
                                  <span className="ekskul-pembina-not-set">
                                    Belum ada pembina
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody> */}
                    <tbody>
  {!Array.isArray(selectedPembinaEkskul?.grade_levels) ||
  selectedPembinaEkskul.grade_levels.length === 0 ? (
    <tr>
      <td
        colSpan={3}
        className="ekskul-pembina-empty"
      >
        Belum ada data pembina
      </td>
    </tr>
  ) : (
    selectedPembinaEkskul.grade_levels.map(
      (grade, gradeIndex) => {
        const pembinaList = Array.isArray(
          grade?.pembina
        )
          ? grade.pembina
          : [];

        /*
          Kalau belum ada pembina,
          tetap tampilkan 1 baris.
        */
        const rowSpan =
          pembinaList.length > 0
            ? pembinaList.length
            : 1;

        /*
          JIKA BELUM ADA PEMBINA
        */
        if (pembinaList.length === 0) {
          return (
            <tr
              key={
                grade?.ysb_grade_level_id ||
                `grade-${gradeIndex}`
              }
              className="ekskul-pembina-grade-row"
            >
              {/* NO */}
              <td
                className="ekskul-pembina-no"
              >
                <span className="module-number-badge">
                  {gradeIndex + 1}
                </span>
              </td>

              {/* KELAS */}
              <td className="ekskul-pembina-grade-cell">
                <span className="ekskul-pembina-grade-badge">
                  {grade?.name_level || "-"}
                </span>
              </td>

              {/* PEMBINA */}
              <td>
                <span className="ekskul-pembina-not-set">
                  Belum ada pembina
                </span>
              </td>
            </tr>
          );
        }

        /*
          JIKA ADA PEMBINA
        */
        return pembinaList.map(
          (teacher, teacherIndex) => {
            const teacherPhoto =
              getTeacherPhoto(teacher);

            const teacherName =
              getTeacherName(teacher);

            const isFirstTeacher =
              teacherIndex === 0;

            return (
              <tr
                key={
                  teacher?.ysb_teacher_id ||
                  teacher?.id ||
                  `${grade?.ysb_grade_level_id}-${teacherIndex}`
                }
                className={`ekskul-pembina-teacher-row ${
                  isFirstTeacher
                    ? "first-grade-row"
                    : ""
                }`}
              >
                {/* =====================
                    NO
                    hanya tampil di row pertama
                ====================== */}
                {isFirstTeacher && (
                  <td
                    rowSpan={rowSpan}
                    className="ekskul-pembina-no ekskul-pembina-rowspan-cell"
                  >
                    <span className="module-number-badge">
                      {gradeIndex + 1}
                    </span>
                  </td>
                )}

                {/* =====================
                    KELAS
                    hanya tampil di row pertama
                ====================== */}
                {isFirstTeacher && (
                  <td
                    rowSpan={rowSpan}
                    className="ekskul-pembina-grade-cell ekskul-pembina-rowspan-cell"
                  >
                    <span className="ekskul-pembina-grade-badge">
                      {grade?.name_level || "-"}
                    </span>
                  </td>
                )}

                {/* =====================
                    NAMA PEMBINA
                ====================== */}
                <td>
                  <div className="ekskul-pembina-teacher">
                    <span className="ekskul-pembina-avatar">
                      {teacherPhoto ? (
                        <img
                          src={teacherPhoto}
                          alt={teacherName}
                        />
                      ) : (
                        getTeacherInitials(
                          teacherName
                        )
                      )}
                    </span>

                    <span className="ekskul-pembina-name">
                      {teacherName}
                    </span>
                  </div>
                </td>
              </tr>
            );
          }
        );
      }
    )
  )}
</tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="ekskul-pembina-modal-footer">
              <button
                type="button"
                className="ekskul-pembina-close-button"
                onClick={closeModalPembina}
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faBookOpen} />
            </span>
            <h4 className="page-title-text">Data Ekstrakurikuler</h4>
          </div>

          <div className="ml-auto menu-navigation-wrapper">
            <Link to="/ekskuls/predikat"
              className="menu-navigation-button"
            >
              Predikat
            </Link>

             <Link
            to="/ekskuls/config-ekskul"
            className="menu-navigation-button"
          >
            <FontAwesomeIcon icon={faGear} />
            <span className="ml-1"> Konfigurasi Ekskul</span>
          </Link>
          </div>
        </div>
      </div>


      <div className="body-content sims-content">
        {/* TAB */}
        <div className="sims-tabs">
          <button
            type="button"
            className={`sims-tab ${
              activeTab === "ekstrakurikuler" ? "active" : ""
            }`}
            onClick={() => setActiveTab("ekstrakurikuler")}
          >
            Ekstrakurikuler
          </button>

          <button
            type="button"
            className={`sims-tab ${
              activeTab === "info" ? "active" : ""
            }`}
            onClick={() => setActiveTab("info")}
          >
            Informasi
          </button>
        </div>

        {/* =========================
            TAB EKSTRAKURIKULER
        ========================== */}
        {activeTab === "ekstrakurikuler" && (
          <>
            <div className="single-toolbar-card">
              <div className="single-filter-side">
                {loading ? (
                  <>
                    <div className="shimmer single-skeleton-select" />
                    <div className="shimmer single-skeleton-button" />
                  </>
                ) : (
                  <>
                    <div className="sims-filter-field">
                      <label className="sims-filter-label">
                        Cabang
                      </label>

                      <select
                        className="sims-filter-select"
                        name="ysb_branch_id"
                        value={formFilter.ysb_branch_id}
                        onChange={handleFilterChange}
                      >
                        <option value="">Pilih Cabang</option>

                        {branches.map((branch, index) => (
                          <option
                            key={branch?.branch_code || index}
                            value={branch?.branch_code || ""}
                          >
                            {branch?.branch_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <button
                      type="button"
                      className="single-filter-button"
                      onClick={handleCari}
                      disabled={
                        !formFilter.ysb_branch_id || isFetching
                      }
                    >
                      Tampilkan Data
                    </button>
                  </>
                )}
              </div>

              <div className="sims-toolbar-actions">
                {Number(permission.create) === 1 && (
                  <button
                    type="button"
                    className="btn btn-create sims-header-button"
                    onClick={() => setModalAdd(true)}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    <span>Tambah Ekstrakurikuler</span>
                  </button>
                )}
              </div>
            </div>

            {isFetching && (
              <div className="sims-loading">
                <PulseLoader color="#3f5bea" size={12} />
              </div>
            )}

            {hasSearched && !isFetching && (
              <>
                <div className="sims-search-wrap mb-3">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="sims-search-icon"
                  />

                  <input
                    type="text"
                    className="sims-search-input"
                    placeholder="Cari ekstrakurikuler..."
                    value={searchKeyword}
                    onChange={(event) =>
                      setSearchKeyword(event.target.value)
                    }
                  />
                </div>

                <div className="sims-table-card">
                  <div className="sims-table-scroll">
                    <table className="sims-table">
                      <thead>
                        <tr>
                          <th className="sims-col-number">
                            No
                          </th>

                          <th>
                            Ekstrakurikuler
                          </th>

                          <th>
                            Keterangan
                          </th>

                          <th className="sims-col-action">
                            Aksi
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {paginatedData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={4}
                              className="sims-empty-state"
                            >
                              <div className="sims-empty-state-content">
                                Data ekstrakurikuler tidak ditemukan
                              </div>
                            </td>
                          </tr>
                        ) : (
                          paginatedData.map((item, index) => (
                            <tr
                              key={
                                item?.id ||
                                `ekskul-${index}`
                              }
                            >
                              <td className="sims-col-number">
                                <span className="sims-number-badge">
                                  {(tablePage - 1) *
                                    rowsPerPage +
                                    index +
                                    1}
                                </span>
                              </td>

                              <td>
                                <span className="sims-text-bold">
                                  {item?.name_matpel || "-"}
                                </span>
                              </td>

                              <td>
                                <span>
                                  {item?.description || "-"}
                                </span>
                              </td>

                              <td className="sims-col-action">
                                <div className="sims-action-wrap ekskul-action-wrap">
                                  {Number(
                                    permission.update
                                  ) === 1 && (
                                    <button
                                      type="button"
                                      className="sims-action-button sims-action-edit"
                                      title="Ubah ekstrakurikuler"
                                      onClick={() =>
                                        openUpdateModal(item)
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faPenToSquare}
                                      />
                                    </button>
                                  )}

                                  {Number(
                                    permission.delete
                                  ) === 1 && (
                                    <button
                                      type="button"
                                      className="sims-action-button sims-action-delete"
                                      title="Hapus ekstrakurikuler"
                                      onClick={() =>
                                        deleteById(item)
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faTrash}
                                      />
                                    </button>
                                  )}

                                  {Number(
                                    permission.update
                                  ) !== 1 &&
                                    Number(
                                      permission.delete
                                    ) !== 1 && (
                                      <span className="sims-muted-text">
                                        -
                                      </span>
                                    )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {filteredData.length > 0 && (
                    <div className="sims-pagination">
                      <div className="sims-pagination-left">
                        <span className="sims-page-info">
                          Menampilkan{" "}
                          <b>
                            {Math.min(
                              (tablePage - 1) *
                                rowsPerPage +
                                1,
                              totalRows
                            )}
                          </b>
                          -
                          <b>
                            {Math.min(
                              tablePage * rowsPerPage,
                              totalRows
                            )}
                          </b>{" "}
                          dari <b>{totalRows}</b> data
                        </span>

                        <select
                          className="sims-page-size"
                          value={rowsPerPage}
                          onChange={(event) => {
                            setRowsPerPage(
                              Number(event.target.value) ||
                                10
                            );
                            setTablePage(1);
                          }}
                        >
                          <option value={10}>
                            10 / halaman
                          </option>

                          <option value={25}>
                            25 / halaman
                          </option>

                          <option value={50}>
                            50 / halaman
                          </option>

                          <option value={100}>
                            100 / halaman
                          </option>
                        </select>
                      </div>

                      <div className="sims-pagination-right">
                        <button
                          type="button"
                          className="sims-page-nav"
                          onClick={() =>
                            goToPage(tablePage - 1)
                          }
                          disabled={tablePage <= 1}
                        >
                          Prev
                        </button>

                        <div className="sims-page-numbers">
                          {pageNumbers.map(
                            (page, index) =>
                              page === "..." ? (
                                <span
                                  key={`dots-${index}`}
                                  className="sims-page-dots"
                                >
                                  ...
                                </span>
                              ) : (
                                <button
                                  type="button"
                                  key={`page-${page}`}
                                  className={`sims-page-number ${
                                    page === tablePage
                                      ? "active"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    goToPage(page)
                                  }
                                >
                                  {page}
                                </button>
                              )
                          )}
                        </div>

                        <button
                          type="button"
                          className="sims-page-nav"
                          onClick={() =>
                            goToPage(tablePage + 1)
                          }
                          disabled={
                            tablePage >= totalPages
                          }
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </>
        )}

        {/* =========================
            TAB INFO
        ========================== */}
        {activeTab === "info" && (
          <>
            <div className="ekskul-info-filter-card">
              <div className="ekskul-info-filter-grid">
                {/* TAHUN AKADEMIK */}
                <div className="ekskul-filter-field">
                  <label className="ekskul-filter-label">
                    Tahun Akademik
                  </label>

                  <select
                    className="ekskul-filter-select"
                    name="ysb_academic_year_id"
                    value={
                      formInfo.ysb_academic_year_id
                    }
                    onChange={handleInfoFilterChange}
                  >
                    <option value="">
                      Pilih Tahun Akademik
                    </option>

                    {academicYears.map(
                      (item, index) => (
                        <option
                          key={item?.id || index}
                          value={item?.id || ""}
                        >
                          {item?.name_year ||
                            item?.name ||
                            "-"}
                        </option>
                      )
                    )}
                  </select>
                </div>

                {/* CABANG */}
                <div className="ekskul-filter-field">
                  <label className="ekskul-filter-label">
                    Cabang
                  </label>

                  <select
                    className="ekskul-filter-select"
                    name="ysb_branch_id"
                    value={formInfo.ysb_branch_id}
                    onChange={handleInfoFilterChange}
                  >
                    <option value="">
                      Pilih Cabang
                    </option>

                    {branches.map(
                      (branch, index) => (
                        <option
                          key={
                            branch?.branch_code ||
                            index
                          }
                          value={
                            branch?.branch_code ||
                            ""
                          }
                        >
                          {branch?.branch_name}
                        </option>
                      )
                    )}
                  </select>
                </div>

                {/* SEKOLAH */}
                <div className="ekskul-filter-field">
                  <label className="ekskul-filter-label">
                    Sekolah
                  </label>

                  <select
                    className="ekskul-filter-select"
                    name="ysb_school_id"
                    value={formInfo.ysb_school_id}
                    onChange={handleInfoFilterChange}
                    disabled={
                      !formInfo.ysb_branch_id ||
                      infoSchoolLoading
                    }
                  >
                    <option value="">
                      {infoSchoolLoading
                        ? "Memuat Sekolah..."
                        : "Pilih Sekolah"}
                    </option>

                    {infoSchools.map(
                      (school, index) => (
                        <option
                          key={
                            school?.school_code ||
                            index
                          }
                          value={
                            school?.school_code ||
                            ""
                          }
                        >
                          {school?.school_name}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>

              <button
                type="button"
                className="ekskul-filter-button"
                onClick={handleInfoCari}
                disabled={
                  infoLoading ||
                  infoSchoolLoading ||
                  !formInfo.ysb_academic_year_id ||
                  !formInfo.ysb_branch_id ||
                  !formInfo.ysb_school_id
                }
              >
                Tampilkan Data
              </button>
            </div>

            {/* LOADING */}
            {infoLoading && (
              <div className="module-loading">
                <PulseLoader
                  color="#3f5bea"
                  size={12}
                />
              </div>
            )}

            {/* TABLE */}
            {hasInfoSearched &&
              !infoLoading && (
                <div className="module-table-card">
                  <div className="module-table-scroll ekskul-info-table-scroll">
                    <table className="module-table ekskul-info-table">
                      <thead>
          <tr>
            <th
              rowSpan={2}
              className="module-col-number"
            >
              No
            </th>

            <th
              rowSpan={2}
              className="ekskul-info-col-name"
            >
              Ekstrakurikuler
            </th>

            <th
              rowSpan={2}
              className="ekskul-info-col-grade"
            >
              Tingkatan
            </th>

            <th
              rowSpan={2}
              className="ekskul-info-col-teacher"
            >
              Pembina Ekstrakurikuler
            </th>

            <th
              colSpan={2}
              className="ekskul-info-col-student"
            >
              Jumlah Siswa
            </th>
          </tr>

          <tr>
            <th className="ekskul-info-col-student">
              Semester 1
            </th>

            <th className="ekskul-info-col-student">
              Semester 2
            </th>
          </tr>
        </thead>

                      <tbody>
                        {infoData.length === 0 ? (
                          <tr>
                            <td
                              colSpan={6}
                              className="module-empty-state"
                            >
                              Data informasi ekstrakurikuler tidak ditemukan
                            </td>
                          </tr>
                        ) : (
                          infoData.map(
                            (item, index) => {
                              const gradeLevels =
                                Array.isArray(
                                  item?.grade_levels
                                )
                                  ? item.grade_levels
                                  : [];

                              const teachers =
                                Array.isArray(
                                  item?.pembina
                                )
                                  ? item.pembina
                                  : [];

                              return (
                                <tr
                                  key={
                                    item?.ysb_matpel_id ||
                                    `info-ekskul-${index}`
                                  }
                                >
                                  {/* NO */}
                                  <td className="module-col-number">
                                    <span className="module-number-badge">
                                      {index + 1}
                                    </span>
                                  </td>

                                  {/* EKSTRAKURIKULER */}
                                  <td>
                                    <span className="module-code-text">
                                      {item?.name_matpel ||
                                        "-"}
                                    </span>
                                  </td>

                                  {/* TINGKATAN */}
                                  <td>
                                    {gradeLevels.length ===
                                    0 ? (
                                      <span className="module-muted-text">
                                        -
                                      </span>
                                    ) : (
                                      <div className="ekskul-info-grade-list">
                                        {gradeLevels.map(
                                          (
                                            grade,
                                            gradeIndex
                                          ) => (
                                            <span
                                              className="ekskul-info-grade-badge"
                                              key={
                                                grade?.ysb_grade_level_id ||
                                                gradeIndex
                                              }
                                            >
                                              {grade?.name_level ||
                                                "-"}
                                            </span>
                                          )
                                        )}
                                      </div>
                                    )}
                                  </td>

                                {/* PEMBINA */}
        <td className="ekskul-info-col-teacher">
          <button
            type="button"
            className="ekskul-pembina-link"
            onClick={() => openModalPembina(item)}
          >
            Lihat Pembina

            {/* {getTotalPembina(item) > 0 && (
              <span className="ekskul-pembina-count">
                {getTotalPembina(item)}
              </span>
            )} */}
          </button>
        </td>

                                  {/* SEMESTER 1 */}
                                  <td className="ekskul-info-col-student">
                                    <span className="ekskul-info-student-total">
                                      {getSemesterTotal(
                                        item,
                                        1
                                      )}
                                    </span>
                                    {/* belum */}
                                  </td>

                                  {/* SEMESTER 2 */}
                                  <td className="ekskul-info-col-student">
                                    <span className="ekskul-info-student-total">
                                      {getSemesterTotal(
                                        item,
                                        2
                                      )}
                                    </span>
                                    {/* belum */}
                                  </td>

                                
                                </tr>
                              );
                            }
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
          </>
        )}
      </div>

    </div>
  );
}
